import contentCategories from '@/shared/lib/constants/categories';
import { FilterState } from '@/shared/lib/filter/model/types';
import { Select } from '@/shared/ui/select';

export interface IContentCategorySelectProps {
  value: FilterState['contentCategories'];
  onChange: (value: FilterState['contentCategories']) => void;
  disabled?: boolean;
}

export default function ContentCategorySelect({
  value: currentValue = [],
  onChange,
  disabled,
}: IContentCategorySelectProps) {
  const convertedCurrent = contentCategories.filter(({ value }) =>
    (currentValue || []).includes(value)
  );

  return (
    <div className="min-w-[210px]">
      <Select
        type="multi"
        multiplyLabel="Categories"
        options={contentCategories.map(({ value, label }) => ({
          value,
          label,
          labelCaption: (
            <div key={value}>
              <span>{label}</span>
            </div>
          ),
        }))}
        current={convertedCurrent}
        onChange={(data) => {
          onChange(data.map(({ value }) => value) as number[]);
        }}
        disabled={disabled}
      />
    </div>
  );
}
